import template from './leave_categories.html';
import tr from '../../lib/default-translator.js';

class AdminLeaveCategoriesViewModel
{
	constructor(page)
	{
		this.page = page;
	}

	show_categories_help()
	{
		Grape.dialog.open('LeaveCategoriesHelp', {});
	};
}

class AdminLeaveCategoriesPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminLeaveCategoriesViewModel(this);
	}

	init()
	{
		document.title = tr('Manage Leave Categories');
		window.current_page_title(tr('Add/Edit Leave Categories'));
	}
}

export default {
	route: '[/]admin/leave_categories',
	page_class: AdminLeaveCategoriesPage,
	template: template,
	template_filename: 'translation/leave_categories'
};
